// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__1bfSR","inputWrap":"Table_inputWrap__3xN94","col":"Table_col__6ruYT","bmiTooltip":"Table_bmiTooltip__2ch5T"};